"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var isScrollingDown_1 = require("../helpers/isScrollingDown");
var Menu_1 = __importDefault(require("./Menu"));
var FloatingCTA_1 = __importDefault(require("./FloatingCTA"));
var StickyHeader = /** @class */ (function (_super) {
    __extends(StickyHeader, _super);
    function StickyHeader() {
        var _this = _super.call(this, constants_1.DATA_STICKY_HEADER) || this;
        _this.CLASS_NAV_VISIBLE = 'nav-visible';
        if (!_this.getElement()) {
            return _this;
        }
        StickyHeader.header = _this.getElement();
        _this.HEADER_STICKY_OFFSET = Math.round(window.innerHeight * (1 / 3));
        _this.nav = _this.getChildElement('nav');
        _this.addHeight();
        _this.initEventListeners();
        return _this;
    }
    StickyHeader.prototype.initEventListeners = function () {
        var _this = this;
        document.addEventListener('scroll', function () {
            _this.documentScroll(_this.HEADER_STICKY_OFFSET);
        });
    };
    StickyHeader.prototype.addHeight = function () {
        StickyHeader.header.style.height = "".concat(StickyHeader.header.offsetHeight, "px");
    };
    StickyHeader.prototype.documentScroll = function (offset) {
        if (!(0, isScrollingDown_1.isScrollingDown)() && document.documentElement.scrollTop > offset) {
            this.isSticky();
            return;
        }
        this.isNotSticky();
    };
    StickyHeader.prototype.isSticky = function () {
        if (!this.getElement().classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.getElement().classList.add(constantsClasses_1.CLASS_STICKY);
        }
        if (!this.nav.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.nav.classList.add(constantsClasses_1.CLASS_STICKY);
        }
        if (!FloatingCTA_1.default.floatingCTA.classList.contains(this.CLASS_NAV_VISIBLE)) {
            FloatingCTA_1.default.floatingCTA.classList.add(this.CLASS_NAV_VISIBLE);
        }
    };
    StickyHeader.prototype.isNotSticky = function () {
        if (Menu_1.default.isOpen) {
            return;
        }
        if (this.getElement().classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.getElement().classList.remove(constantsClasses_1.CLASS_STICKY);
        }
        if (this.nav.classList.contains(constantsClasses_1.CLASS_STICKY)) {
            this.nav.classList.remove(constantsClasses_1.CLASS_STICKY);
        }
        if (FloatingCTA_1.default.floatingCTA.classList.contains(this.CLASS_NAV_VISIBLE)) {
            FloatingCTA_1.default.floatingCTA.classList.remove(this.CLASS_NAV_VISIBLE);
        }
    };
    return StickyHeader;
}(AbstractComponent_1.default));
exports.default = StickyHeader;
